export const MAX_TEM_QUANTITY = 999
export const INVALID_NUMBER = 'Số không đúng định dạng!'
